import { render, staticRenderFns } from "./NotificationRecipientsInput.vue?vue&type=template&id=048eb57f&scoped=true"
import script from "./NotificationRecipientsInput.vue?vue&type=script&lang=js"
export * from "./NotificationRecipientsInput.vue?vue&type=script&lang=js"
import style0 from "./NotificationRecipientsInput.vue?vue&type=style&index=0&id=048eb57f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "048eb57f",
  null
  
)

export default component.exports